import { createRoot } from 'react-dom/client';
import * as qwApplianceManager from './common/clients/qwApplianceManager';
import * as qsGateway from './common/clients/qs-gateway';
import * as qwReports from './common/clients/qwReports';
import * as monarch from './common/clients/monarch';
import * as qwPartners from './common/clients/qwPartners';
import { store } from './app/store';
import App from './app/App';

qwApplianceManager.setStore(store);
qsGateway.setStore(store);
qwReports.setStore(store);
monarch.setStore(store);
qwPartners.setStore(store);

const root = createRoot(document.getElementById('root'));
root.render(<App store={store} />);
